import React from "react";
import { Col } from "react-bootstrap";
import { IItemDetail } from "../../../../models/try2Combo";
import { persistZero } from "../../../../helpers/helperMethods";

const ItemDetail: React.FC<IItemDetail> = (props) => {
  const {
    itemDetails,
    originalPrice,
    price,
    description,
    name,
    selectedLocation,
  } = props;
  return (
    <>
      {itemDetails && selectedLocation ? (
        <Col xs="12">
          <p className="p-18 mt-md-40 mt-4 text-start mb-0 f-sm-s14 clr-dark-grey">
            {description}
            <br />
            <span className="pt-3 d-inline-block clr-text-grey ">
              {name} -
              <span
                className={`${price > originalPrice && "text-danger"}`}
                data-testid="priceTag"
              >
                {" "}
                Total: ${persistZero(price)}{" "}
              </span>
            </span>
          </p>
          <hr className="mb-4 mb-md-10" />
        </Col>
      ) : (
        ""
      )}
    </>
  );
};

export default ItemDetail;
